import appStore from 'store';
import api from './api';

const store = {
    namespaced: true,
    state: {
        categoryTotal: 0,
        categoryList: [],
        selectionTotal: 0,
        selectionList: [],
        recommendTotal: 0,
        recommendList: [],
        nonstopList: [],
    },
    mutations: {
        setData(state, payload) {
            state[payload.key] = payload.value;
        },
    },
    actions: {
        getCategoryList({ commit }, query) {
            api.getCategoryList(query).then(({ data }) => {
              if(data) {
                commit('setData', {
                  key: 'categoryList',
                  value: data.list
                });
                commit('setData', {
                  key: 'categoryTotal',
                  value: data.totalCount
                });
              }
            });
        },

        updateShowedStatus(context, data) {
            return api.updateShowedStatus(data);
        },
        
        deleteCategory(contest, data) {
            return api.deleteCategory(data);
        },

        createOrUpdateProductCategory(context, data) {
            return api.createOrUpdateProductCategory(data);
        },
        
        getSelectionList({ commit }, query) {
            api.getSelectionList(query).then(({ data }) => {
              if(data) {
                commit('setData', {
                  key: 'selectionList',
                  value: data.list
                });
                commit('setData', {
                  key: 'selectionTotal',
                  value: data.totalCount
                });
              }
            });
        },

        updateSelectionShowedStatus(context, data) {
            return api.updateSelectionShowedStatus(data);
        },
        
        deleteSelection(contest, data) {
            return api.deleteSelection(data);
        },

        createOrUpdateProductSelection(context, data) {
            return api.createOrUpdateProductSelection(data);
        },

        getRecommendList({ commit }, query) {
            api.getRecommendList(query).then(({ data }) => {
              if(data) {
                commit('setData', {
                  key: 'recommendList',
                  value: data.list
                });
                commit('setData', {
                  key: 'recommendTotal',
                  value: data.totalCount
                });
              }
            });
        },

        updateRecommendHomePage(context, data) {
            return api.updateRecommendHomePage(data);
        },

        deleteRecommend(contest, data) {
            return api.deleteRecommend(data);
        },

        createOrUpdateProductRecommed(context, data) {
            return api.createOrUpdateProductRecommed(data);
        },

        getNonstopList({ commit }) {
            api.getNonstopList().then(({ data }) => {
              if(data) {
                commit('setData', {
                  key: 'nonstopList',
                  value: data
                });
              }
            });
        },

        updateFinancilNonstop(context, data) {
            return api.updateFinancilNonstop(data);
        },
        
        updateMiningExplain(context, data) {
            return api.updateMiningExplain(data);
        },
        
        refreshFinancialProductCache(context) {
          return api.refreshFinancialProductCache();
      }
        
    }
}

appStore.registerModule('ProductManage', store);
